<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35.919 24.506"
        style="fill: currentColor"
    >
        <g id="download-cloud" transform="translate(-1.435 -11.23)">
            <path
                id="layer2"
                d="M27.407,32.687h1.724a7.472,7.472,0,1,0,0-14.945h-.287a9.772,9.772,0,0,0-18.566,2.529A6.323,6.323,0,1,0,8.439,32.687h2.874"
                transform="translate(0 0)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-width="1.5"
            />
            <path
                id="layer1"
                d="M28.6,30V42.646m-4.6-4.6,4.6,4.6,4.6-4.6"
                transform="translate(-9.239 -7.66)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-width="1.5"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-download",
});
</script>
